import { render, staticRenderFns } from "./PopoverVariant.vue?vue&type=template&id=3322b3b8"
import script from "./PopoverVariant.vue?vue&type=script&lang=js"
export * from "./PopoverVariant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports